import { Box, Paper, Typography, Divider, Container } from '@mui/material';

const SettingsPage = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        ⚙️ 관리자 설정
      </Typography>

      <Paper sx={{ p: 3, mb: 4 }}>
        <Typography variant="subtitle1" gutterBottom>
          🔧 공지
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Typography variant="body2" color="text.secondary">
          향후 관리자 전용 기능 (예: 카카오 알림 설정, 관리자 계정 관리, 시스템 로그 등)을 이곳에서 설정할 수 있도록 확장할 예정입니다.
        </Typography>
      </Paper>

      {/* 단가표 관리는 좌측 메뉴의 "단가표 관리" 페이지에서 진행하세요. */}
    </Container>
  );
};

export default SettingsPage;
